import moment from 'moment'

const state = {
	data: {
		paticient: {
			dashboard: []
		},
	}
}

const getters = {
	GET_PIN_PATIENT_DASHBOARD : state => {
		return state.data.paticient.dashboard
	},
	GET_PIN_IS_PATIENT_IN_DASHBOARD : state => item => {
		return !!state.data.paticient.dashboard.filter(element => element != null).find(element => element.id == item.id)
	}
}

const mutations = {
	POST_PIN_PATIENT_DASHBOARD : (state, item) => {
		state.data.paticient.dashboard.push(item)
	},
	DELETE_PIN_PATIENT_DASHBOARD : (state, item) => {
		state.data.paticient.dashboard = [
			...state.data.paticient.dashboard.filter(element => element !== null && element.id !== item.id)
		]
	}
}

const actions = {
	POST_PIN_PATIENT_DASHBOARD : (context, { refThis, item }) => {
		context.commit('POST_PIN_PATIENT_DASHBOARD', item)
	},
	DELETE_PIN_PATIENT_DASHBOARD : (context, { refThis, item }) => {
		context.commit('DELETE_PIN_PATIENT_DASHBOARD', item)
	}
}

export default {
	state, getters, mutations, actions
}



// WEBPACK FOOTER //
// ./src/store/modules/pin.js